import { func } from "prop-types";

import styled from "styled-components";

import { TTJ_ACTION_FLOW } from "Flocknote/GlobalComponents/Modal/contentKeys";
import { usePermissions } from "Flocknote/apiHooks";
import { useModal } from "Flocknote/stateHooks";

import { useClearActiveAction } from "Dashboard/components/WhatsNext/whatsNextStore";
import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionWrapper from "NavBar/components/settings/SettingsOptionWrapper";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import { useIsTextToJoinButtonFlashing } from "NavBar/stateHooks";
import { menuIconProps } from "NavBar/styleConstants";

import FnrShineButton from "UI/FnrButton3/FnrShineButton";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";
import { navAccentColors } from "UI/colors";

import { addOpacity } from "Utilities/Colors/colorUtils";
import flash from "Utilities/interpolations/flash";

const SettingsContent = ({ setCloseTrigger }) => {
  const [, { openModal }] = useModal();
  const [{ canManageTTJ = true }] = usePermissions();
  const clearActiveAction = useClearActiveAction();

  const isTextToJoinButtonFlashing = useIsTextToJoinButtonFlashing();

  return (
    <SettingsOptionsWrapper>
      {canManageTTJ && (
        <SFlashingButton
          $isFlashing={isTextToJoinButtonFlashing}
          $flashToColor={addOpacity(navAccentColors.groups[0], 0.5)}
          borderRadius={8}
          data-cy="NavBar_TextToJoin"
          onClick={() => {
            openModal(TTJ_ACTION_FLOW, {
              groupStatus: "pending",
              flowType: "creation",
            });
            setCloseTrigger({});
            clearActiveAction();
          }}
        >
          <SettingsOptionWrapper>
            <FnrContainedIcon icon="message-sms fad" {...menuIconProps} />
            <FnrTypography {...menuTypographyProps}>Text-to-Join</FnrTypography>
          </SettingsOptionWrapper>
        </SFlashingButton>
      )}
    </SettingsOptionsWrapper>
  );
};

SettingsContent.propTypes = { setCloseTrigger: func };

const SFlashingButton = styled(FnrShineButton)`
  ${flash}
`;

export default SettingsContent;
